/**
 * Force product thumbnail Swiper to stay VERTICAL at all screen sizes (768px+)
 * AND match thumbnail container height to main image container
 * Does NOT run on mobile (767px and below)
 */

(function() {
  function forceVerticalThumbnails() {
    // Only run on desktop/tablet (768px+)
    if (window.innerWidth < 768) {
      // On mobile, remove any desktop styles we may have added
      const thumbnailOuter = document.querySelector('.product__media-sublist-outer');
      if (thumbnailOuter) {
        thumbnailOuter.style.maxHeight = '';
      }
      return;
    }
    
    // Find the thumbnail Swiper instance
    const thumbnailSwiper = document.querySelector('.product__media-sublist.swiper');
    const thumbnailOuter = document.querySelector('.product__media-sublist-outer');
    const mainImageContainer = document.querySelector('.product__media-list');
    
    if (!thumbnailSwiper || !thumbnailOuter || !mainImageContainer) return;
    
    // MATCH HEIGHTS: Set thumbnail container height to main image container height
    const mainHeight = mainImageContainer.offsetHeight;
    if (mainHeight > 0) {
      thumbnailOuter.style.maxHeight = mainHeight + 'px';
    }
    
    // Check if Swiper is initialized
    if (thumbnailSwiper.swiper) {
      const swiperInstance = thumbnailSwiper.swiper;
      
      // Force change to vertical direction
      if (swiperInstance.params.direction !== 'vertical') {
        swiperInstance.changeDirection('vertical');
        swiperInstance.update();
      }
      
      // Remove horizontal class, add vertical class
      thumbnailSwiper.classList.remove('swiper-horizontal');
      thumbnailSwiper.classList.add('swiper-vertical');
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceVerticalThumbnails);
  } else {
    forceVerticalThumbnails();
  }
  
  // Run after a short delay to catch Swiper initialization
  setTimeout(forceVerticalThumbnails, 100);
  setTimeout(forceVerticalThumbnails, 500);
  setTimeout(forceVerticalThumbnails, 1000); // Extra delay for images to load
  
  // Run on window resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(forceVerticalThumbnails, 250);
  });
  
  // Run when Shopify sections reload (theme editor)
  document.addEventListener('shopify:section:load', forceVerticalThumbnails);
  
  // Run when images load (height may change)
  window.addEventListener('load', forceVerticalThumbnails);
})();